import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'jquery/dist/jquery.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'lodash'
import 'slugify'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import GAuth from 'vue-google-oauth2'
import 'bootstrap-steps/dist/bootstrap-steps.css'

const gauthOption = {
  clientId: '442428738590-5puhrblvg5oed0bor6fmhvi4tveoscjr.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(GAuth, gauthOption)
Vue.use(VueTimepicker)
Vue.use(VuejsDialog)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false
Vue.component('vue-timepicket', VueTimepicker);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
